export default {"src":"/_next/static/media/police.562dc0ef.svg","height":205,"width":188};